import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import AdminDashboardLayout from "../../components/AdminDashboardLayout/AdminDashboardLayout";
import * as bootstrap from "bootstrap";
import Select from "react-select";
import AsyncSelect from "react-select/async";

const IndestryManagementPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  const [industries, setIndustries] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [activeTab, setActiveTab] = useState("domains");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [loading, setLoading] = useState(false);
  const [domains, setDomains] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);
  const [selectedIndustryId, setSelectedIndustryId] = useState("");
  const [modalMode, setModalMode] = useState("add");
  const [metadata, setMetadata] = useState({});
  const [metadataSpecialties, setMetadataSpecialties] = useState({});
  const [pageSize, setPageSize] = useState(12);

  const [stats, setStats] = useState({
    industriesCount: 0,
    specialitiesCount: 0,
    unusedIndustriesCount: 0,
    unusedSpecialitiesCount: 0,
  });
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIndustryName, setSelectedIndustryName] = useState("");
  const [specialities, setSpecialities] = useState([]);
  const [speakers, setSpeakers] = useState([]);

  const loadIndustriesOptions = async (inputValue) => {
    try {
      const response = await axiosInstance.get("/api/v1/admins/industry", {
        params: {
          page: 1,
          pageSize: 20,
          keyword: inputValue.trim(),
        },
      });

      const items = response.data.items || [];

      return items.map((item) => ({
        value: item.id,
        label: item.arabicName,
      }));
    } catch (error) {
      console.error("Error loading industries:", error);
      return [];
    }
  };

  const handleSearch = () => {
    if (activeTab === "domains") {
      fetchIndustries(1);
    } else if (activeTab === "specialties") {
      fetchSpecialities();
    }
  };

  const getFilterId = (type) => {
    switch (type) {
      case "domains":
        return 1;
      case "specialties":
        return 2;
      default:
        return 0;
    }
  };

  const fetchIndustries = async (page = 1) => {
    setLoading(true);
    try {
      const filterId = getFilterId(filterType);

      const params = { page };

      if (filterType !== "all") {
        params.filter = filterId;
      }

      if (searchTerm.trim() !== "") {
        params.keyword = searchTerm.trim();
      }

      const response = await axiosInstance.get("/api/v1/admins/industry", {
        params,
      });

      const items = response.data.items || [];
      const meta = response.data.metadata;

      const formatted = items.map((item) => ({
        id: item.id,
        name: item.arabicName,
        nameEn: item.englishName,
        description: item.arabicDescription,
        image: item.imagePath,
        specialitiesCount: item.specialitiesCount || 0,
      }));

      setIndustries(formatted);
      setMetadata(meta); // 🔴 أضف هذا
      setCurrentPage(meta?.pageNumber || 1);
      setTotalPages(meta?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching industries:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSpecialities = async (page = 1) => {
    setLoading(true);
    try {
      const filterId = getFilterId(filterType);

      const params = { page };

      if (filterType !== "all") {
        params.filter = filterId;
      }

      if (searchTerm.trim() !== "") {
        params.keyword = searchTerm.trim();
      }

      const response = await axiosInstance.get(`/api/v1/admins/specialities`, {
        params,
      });

      const data = response.data;

      setSpecialties(data.items || []);
      setMetadataSpecialties(data.metadata || {}); // 🔴 أضف هذا
      setTotalPages(data.totalPages || 1);
      setCurrentPage(page);
    } catch (error) {
      console.error("Error fetching specialties:", error);
      setSpecialties([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "domains") {
      const shouldRefetch =
        filterType !== "all" || (searchTerm && searchTerm.trim() !== "");
      if (shouldRefetch) {
        fetchIndustries(1);
      } else {
        fetchIndustries();
      }
    } else if (activeTab === "specialties") {
      fetchSpecialities(1);
    }
  }, [filterType, searchTerm, activeTab]);

  const fetchSpecialitiesByIndustry = async (industryId, industryName) => {
    try {
      setLoading(true);
      setSelectedIndustryName(industryName);
      const response = await axiosInstance.get(`/api/v1/admins/specialities`, {
        params: { industryId },
      });
      const data = response.data?.items || [];
      setSpecialities(data);
      setSpeakers([]);

      // عرض المودال بعد تحميل البيانات
      const modal = new bootstrap.Modal(
        document.getElementById("viewSpecialtiesModal")
      );
      modal.show();
    } catch (error) {
      console.error("فشل في جلب التخصصات:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSpeakersByIndustry = async (industryId, industryName) => {
    try {
      setLoading(true);
      setSelectedIndustryName(industryName);

      const response = await axiosInstance.get(`/api/v1/admins/speakers`, {
        params: { industryId },
      });

      const data = response.data?.items || [];
      setSpeakers(data);
      setSpecialities([]);
    } catch (error) {
      console.error("فشل في جلب المتحدثين:", error);
    } finally {
      setLoading(false);
      const modal = new bootstrap.Modal(
        document.getElementById("viewSpecialtiesModal")
      );
      modal.show();
    }
  };

  const fetchSpeakersBySpeciality = async (specialityId, specialityName) => {
    try {
      setLoading(true);
      setSelectedIndustryName(specialityName);
      const response = await axiosInstance.get(`/api/v1/admins/speakers`, {
        params: { specialityId },
      });
      const data = response.data?.items || [];
      setSpeakers(data);
      setSpecialities([]);
    } catch (error) {
      console.error("فشل في جلب المتحدثين حسب التخصص:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveIndustry = () => {
    const name = document.getElementById("editIndustryNameAr").value.trim();
    const nameEn = document.getElementById("editIndustryNameEn").value.trim();
    const description = document
      .getElementById("editIndustryDescription")
      .value.trim();
    const englishDescription = document
      .getElementById("editIndustryEnglishDescription")
      .value.trim();
    const imageInput = document.getElementById("editIndustryImage");
    const image = imageInput.files[0];

    handleSubmitIndustry({
      ...selectedIndustry,
      name,
      nameEn,
      description,
      englishDescription,
      image,
      mode: modalMode, // "add" or "edit"
    });
  };

  const openEditIndustryModal = (industry = null) => {
    setSelectedIndustry(
      industry || {
        id: "",
        name: "",
        nameEn: "",
        description: "",
        image: "",
      }
    );
    setTimeout(() => {
      document.getElementById("editIndustryNameAr").value =
        industry?.name || "";
      document.getElementById("editIndustryNameEn").value =
        industry?.nameEn || "";
      document.getElementById("editIndustryDescription").value =
        industry?.description || "";

      const previewImg = document.querySelector(
        "#editIndustryImagePreview img"
      );
      const previewContainer = document.getElementById(
        "editIndustryImagePreview"
      );

      if (industry?.image) {
        previewImg.src = industry.image;
        previewContainer.style.display = "block";
      } else {
        previewImg.src = "";
        previewContainer.style.display = "none";
      }
    }, 100); // تأخير بسيط لضمان تحميل العناصر داخل المودال

    setModalMode(industry ? "edit" : "add");
    const modal = new bootstrap.Modal(
      document.getElementById("editIndustryModal")
    );
    modal.show();
    setTimeout(() => {
      const removeBtn = document.getElementById("removeEditIndustryImage");
      const imageInput = document.getElementById("editIndustryImage");

      if (removeBtn && imageInput) {
        removeBtn.onclick = () => {
          const previewImg = document.querySelector(
            "#editIndustryImagePreview img"
          );
          const previewContainer = document.getElementById(
            "editIndustryImagePreview"
          );

          imageInput.value = "";
          previewImg.src = "";
          previewContainer.style.display = "none";
        };

        imageInput.onchange = function () {
          const file = this.files[0];
          const previewImg = document.querySelector(
            "#editIndustryImagePreview img"
          );
          const previewContainer = document.getElementById(
            "editIndustryImagePreview"
          );

          if (file) {
            previewImg.src = URL.createObjectURL(file);
            previewContainer.style.display = "block";
          } else {
            previewImg.src = "";
            previewContainer.style.display = "none";
          }
        };
      }
    }, 200);
  };

  const handleSubmitIndustry = async ({
    id,
    name,
    nameEn,
    description,
    image,
    mode = "add",
  }) => {
    const formData = new FormData();
    formData.append("ArabicName", name);
    formData.append("EnglishName", nameEn);
    formData.append("ArabicDescription", description);
    formData.append("EnglishDescription", description);
    if (image) formData.append("ImagePath", image);

    try {
      let res;
      if (mode === "edit" && id) {
        res = await axiosInstance.put(
          `/api/v1/admins/industry/${id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        setIndustries((prev) =>
          prev.map((industry) =>
            industry.id === +id ? { ...industry, ...res.data } : industry
          )
        );
        toast.success("تم التحديث بنجاح");
      } else {
        res = await axiosInstance.post(`/api/v1/admins/industry`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setIndustries((prev) => [...prev, res.data]);
        toast.success("تمت الإضافة بنجاح");
      }

      bootstrap.Modal.getInstance(
        document.getElementById("editIndustryModal")
      )?.hide();
    } catch (error) {
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.title ||
        error.message;

      const lines = errorMessage.split(".").filter((line) => line.trim());
      lines.forEach((line) => toast.error(line.trim()));
    }
  };

  const handleDeleteIndustry = (id) => {
    if (window.confirm(t("confirm.deleteIndustry"))) {
      axiosInstance
        .delete(`/api/v1/admins/industry/${id}`)
        .then(() => {
          setIndustries((prev) => prev.filter((item) => item.id !== id));
        })
        .catch((error) => {
          console.error(t("errors.deleteIndustry"), error);
        });
    }
  };

  const fetchSpecialties = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/api/v1/admins/specialities");
      const data = response.data.items;

      const formatted = data.map((item) => ({
        id: item.id,
        arabicName: item.arabicName,
        englishName: item.englishName,
        arabicDescription: item.arabicDescription,
        industryName: item.industry?.arabicName || "",
        industryId: item.industryId,
      }));

      setSpecialties(formatted);
    } catch (error) {
      console.error("Error fetching specialties:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveSpecialty = () => {
    if (modalMode === "edit") {
      handleEditSpecialty(selectedSpecialty.id, selectedSpecialty);
    } else {
      handleAddSpecialty(selectedSpecialty);
    }

    // إغلاق المودال بعد الحفظ
    bootstrap.Modal.getInstance(
      document.getElementById("editSpecialtyModal")
    )?.hide();
  };

  const openEditSpecialtyModal = (specialty = null) => {
    const isEdit = specialty !== null;

    if (isEdit) {
      const industry = industries.find(
        (ind) => ind.id === specialty.industryId
      );

      setSelectedSpecialty({
        ...specialty,
        industryLabel: industry ? industry.name : "",
        industryId: specialty.industryId || "",
      });

      setSelectedIndustryName(industry ? industry.name : "");
      setSelectedIndustryId(specialty.industryId);
    } else {
      setSelectedSpecialty({
        id: "",
        arabicName: "",
        englishName: "",
        arabicDescription: "",
        industryId: selectedIndustryId || "",
        industryLabel: selectedIndustryName || "",
      });
    }

    setModalMode(isEdit ? "edit" : "add");

    // فتح المودال
    const modal = new bootstrap.Modal(
      document.getElementById("editSpecialtyModal")
    );
    modal.show();
  };

  const handleEditSpecialty = async (id, values) => {
    try {
      if (!validateSpecialtyPayload(values)) return;

      await axiosInstance.put(`/api/v1/admins/specialities/${id}`, values);
      fetchSpecialties();
      toast.success("تم التعديل بنجاح");
    } catch (error) {
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.title ||
        error.message;
      toast.error(`فشل في تعديل التخصص: ${errorMessage}`);
    }
  };

  const handleAddSpecialty = async (values) => {
    try {
      if (!validateSpecialtyPayload(values)) return;

      await axiosInstance.post(`/api/v1/admins/specialities`, values);
      fetchSpecialties();
      toast.success("تمت الإضافة بنجاح");
    } catch (error) {
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.title ||
        error.message;
      toast.error(`فشل في إضافة التخصص: ${errorMessage}`);
    }
  };

  const validateSpecialtyPayload = (values) => {
    if (
      !values.arabicName?.trim() ||
      !values.englishName?.trim() ||
      !values.arabicDescription?.trim() ||
      !values.industryId
    ) {
      toast.error("يرجى ملء جميع الحقول المطلوبة");
      return false;
    }
    return true;
  };

  const handleDeleteSpecialty = async (id) => {
    if (window.confirm("هل أنت متأكد أنك تريد حذف هذا التخصص؟")) {
      try {
        await axiosInstance.delete(`/api/v1/admins/specialities/${id}`);
        setSpecialties((prev) => prev.filter((s) => s.id !== id));
      } catch (error) {
        console.error("فشل في حذف التخصص:", error);
      }
    }
  };

  const renderPaginationItems = () => {
    const totalPages =
      activeTab === "domains"
        ? metadata?.totalPages || 0
        : metadataSpecialties?.totalPages || 0;

    const pageButtons = [];

    // الحد الأقصى لأزرار الصفحات التي تظهر
    const maxPagesToShow = 7;

    if (totalPages <= maxPagesToShow) {
      // لو الصفحات قليلة، نعرضهم كلهم
      for (let i = 1; i <= totalPages; i++) {
        pageButtons.push(i);
      }
    } else {
      const addPage = (page) => pageButtons.push(page);

      addPage(1);

      let startPage = Math.max(2, currentPage - 2);
      let endPage = Math.min(totalPages - 1, currentPage + 2);

      if (startPage > 2) {
        pageButtons.push("left-ellipsis");
      } else {
        startPage = 2;
      }

      if (endPage < totalPages - 1) {
      } else {
        endPage = totalPages - 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        addPage(i);
      }

      if (endPage < totalPages - 1) {
        pageButtons.push("right-ellipsis");
      }

      addPage(totalPages);
    }

    return pageButtons.map((page, idx) => {
      if (page === "left-ellipsis" || page === "right-ellipsis") {
        return (
          <li key={idx} className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }

      return (
        <li
          key={idx}
          className={`page-item ${currentPage === page ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => {
              if (activeTab === "domains") {
                fetchIndustries(page);
              } else if (activeTab === "specialties") {
                fetchSpecialities(page);
              }
            }}
          >
            {page}
          </button>
        </li>
      );
    });
  };

  useEffect(() => {
    axiosInstance
      .get("/api/v1/admins/statistics/industries")
      .then((res) => {
        setStats(res.data);
      })
      .catch((error) => {
        console.error("Error fetching statistics:", error);
      });
  }, []);

  return (
    <AdminDashboardLayout pageTitle="إدارة القطاعات" dir={direction}>
      {/* العنوان ومسارات التصفح */}
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="mb-1">{t("domainManagement")}</h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">{t("dashboard")}</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("domains")}
                  </li>
                </ol>
              </nav>
            </div>
            <div>
              <button
                className="btn btn-primary-custom me-2"
                onClick={() => openEditIndustryModal(null)}
              >
                <i className="fas fa-plus-circle me-2"></i>
                <span>{t("addIndustry")}</span>
              </button>

              <button
                className="btn btn-secondary-custom"
                onClick={() => openEditSpecialtyModal(null)}
              >
                <i className="fas fa-plus-circle me-2"></i>
                <span>{t("addSpecialty")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* بطاقات الإحصائيات */}
      <div className="row mb-4">
        {/* عدد المجالات */}
        <div className="col-sm-6 col-xl-3 mb-3">
          <div className="stat-card">
            <div className="icon bg-primary-custom text-white">
              <i className="fas fa-th-large"></i>
            </div>
            <div className="number">{stats.totalIndustriesCount}</div>
            <div className="label">{t("stats.totalIndustries")}</div>
            <div className="progress mt-3" style={{ height: "5px" }}>
              <div
                className="progress-bar bg-primary-custom"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>
        </div>

        {/* عدد التخصصات */}
        <div className="col-sm-6 col-xl-3 mb-3">
          <div className="stat-card">
            <div className="icon bg-secondary-custom text-white">
              <i className="fas fa-list"></i>
            </div>
            <div className="number">{stats.totalSpecialitiesCount}</div>
            <div className="label">{t("stats.totalSpecialities")}</div>
            <div className="progress mt-3" style={{ height: "5px" }}>
              <div
                className="progress-bar bg-secondary-custom"
                style={{ width: "80%" }}
              ></div>
            </div>
          </div>
        </div>

        {/* مجالات غير مستخدمة */}
        <div className="col-sm-6 col-xl-3 mb-3">
          <div className="stat-card">
            <div className="icon bg-warning text-white">
              <i className="fas fa-ban"></i>
            </div>
            <div className="number">{stats.unusedIndustriesCount}</div>
            <div className="label">{t("stats.unusedIndustries")}</div>
            <div className="progress mt-3" style={{ height: "5px" }}>
              <div
                className="progress-bar bg-warning"
                style={{ width: "25%" }}
              ></div>
            </div>
          </div>
        </div>

        {/* تخصصات غير مستخدمة */}
        <div className="col-sm-6 col-xl-3 mb-3">
          <div className="stat-card">
            <div className="icon bg-danger text-white">
              <i className="fas fa-tags"></i>
            </div>
            <div className="number">{stats.unusedSpecialitiesCount}</div>
            <div className="label">{t("stats.unusedSpecialities")}</div>
            <div className="progress mt-3" style={{ height: "5px" }}>
              <div
                className="progress-bar bg-danger"
                style={{ width: "30%" }}
              ></div>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="card">
        <div className="card-body">
          {/* البحث */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-md-8">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("searchPlaceholder")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button
                          className="btn btn-primary-custom"
                          type="button"
                          onClick={handleSearch}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <select
                        className="form-select"
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                      >
                        <option value="all">{t("Filter.all")}</option>
                        <option value="domains"> {t("Used Only")} </option>
                        <option value="specialties"> {t("Unused Only")} </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* الجدول */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  {/* التابات */}
                  <ul className="nav nav-tabs card-header-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link text-dark ${
                          activeTab === "domains" ? "active" : ""
                        }`}
                        type="button"
                        onClick={() => setActiveTab("domains")}
                        role="tab"
                      >
                        {t("industries")}
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link text-dark ${
                          activeTab === "specialties" ? "active" : ""
                        }`}
                        type="button"
                        onClick={() => setActiveTab("specialties")}
                        role="tab"
                      >
                        {t("specialties")}
                      </button>
                    </li>
                  </ul>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    {activeTab === "domains" ? (
                      // جدول القطاعات
                      <table className="table table-hover align-middle">
                        <thead>
                          <tr>
                            <th width="50" className="text-center">
                              #
                            </th>
                            <th width="80" className="text-center">
                              {t("image")}
                            </th>
                            <th>{t("field")}</th>
                            <th>{t("description")}</th>
                            <th width="110" className="text-center">
                              {t("specialties")}
                            </th>
                            {/* <th>{t("speakers")}</th> */}
                            <th width="140" className="text-center">
                              {t("actions")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {industries.map((industry, index) => (
                            <tr key={industry.id}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-center">
                                <img
                                  src={industry.image}
                                  alt={industry.name}
                                  className="domain-image"
                                />
                              </td>
                              <td>
                                <div>
                                  <span className="fw-medium">
                                    {industry.name}
                                  </span>
                                  <small className="text-muted d-block">
                                    {industry.nameEn}
                                  </small>
                                </div>
                              </td>
                              <td>{industry.description}</td>
                              <td className="text-center">
                                <div
                                  className="specialties-count"
                                  onClick={() =>
                                    fetchSpecialitiesByIndustry(
                                      industry.id,
                                      industry.arabicName ||
                                        industry.englishName ||
                                        "بدون اسم"
                                    )
                                  }
                                >
                                  <span>{industry.specialitiesCount}</span>
                                  <i className="fas fa-eye ms-1"></i>
                                </div>
                              </td>

                              {/* <td className="text-center">
                                <div
                                  className="specialties-count"
                                >
                                  <span>{industry.speakersCount}</span>
                                  <i className="fas fa-user-tie ms-1"></i>
                                </div>
                              </td> */}

                              <td>
                                <div className="action-buttons">
                                  <button
                                    type="button"
                                    className="btn-action btn-edit"
                                    onClick={() =>
                                      openEditIndustryModal(industry)
                                    }
                                    title={t("edit")}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-action btn-delete"
                                    onClick={() =>
                                      handleDeleteIndustry(industry.id)
                                    }
                                    title={t("delete")}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-action btn-add"
                                    onClick={() => openEditIndustryModal(null)}
                                    title={t("addSpecialty")}
                                  >
                                    <i className="fas fa-plus"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      // جدول التخصصات:
                      <table className="table table-hover align-middle">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{t("name")}</th>
                            <th>{t("field")}</th>
                            <th>{t("description")}</th>
                            <th>{t("speakers")}</th>
                            <th>{t("actions")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {console.log("Specialties data:", specialties)}
                          {specialties &&
                            specialties.length > 0 &&
                            specialties.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div>
                                    <span className="fw-medium">
                                      {item.arabicName}
                                    </span>
                                    <small className="text-muted d-block">
                                      {item.englishName}
                                    </small>
                                  </div>
                                </td>

                                <td>{item.industryName}</td>
                                <td>{item.arabicDescription}</td>

                                <td className="text-center">
                                  <div
                                    className="specialties-count"
                                    onClick={() =>
                                      fetchSpeakersBySpeciality(
                                        item.id,
                                        item.arabicName ||
                                          item.englishName ||
                                          "بدون اسم"
                                      )
                                    }
                                  >
                                    <span>{item.speakersCount}</span>
                                    <i className="fas fa-user-tie ms-1"></i>
                                  </div>
                                </td>

                                <td>
                                  <div className="action-buttons">
                                    <button
                                      className="btn-action btn-edit"
                                      title={t("edit")}
                                      onClick={() =>
                                        openEditSpecialtyModal(item)
                                      }
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                      className="btn-action btn-delete"
                                      title={t("delete")}
                                      onClick={() =>
                                        handleDeleteSpecialty(item.id)
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          {loading && <p>جاري التحميل...</p>}

                          {specialities.length > 0 && (
                            <>
                              <h5>التخصصات في "{selectedIndustryName}"</h5>
                              <ul>
                                {specialities.map((s) => (
                                  <li key={s.id}>
                                    {s.arabicName || s.englishName}
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}

                          {speakers.length > 0 && (
                            <>
                              <h5>المتحدثين في "{selectedIndustryName}"</h5>
                              <ul>
                                {speakers.map((s) => (
                                  <li key={s.id}>{s.fullName}</li>
                                ))}
                              </ul>
                            </>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  {/* pagination */}
                  {(activeTab !== "specialties" ||
                    (metadata?.totalPages && metadata.totalPages > 1)) && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        <span>
                          عرض {(currentPage - 1) * pageSize + 1} إلى{" "}
                          {Math.min(
                            currentPage * pageSize,
                            activeTab === "domains"
                              ? metadata?.totalCount || 0
                              : metadataSpecialties?.totalCount || 0
                          )}{" "}
                          من{" "}
                          {activeTab === "domains"
                            ? metadata?.totalCount || 0
                            : metadataSpecialties?.totalCount || 0}{" "}
                          {activeTab === "domains" ? "مجالات" : "تخصصات"}
                        </span>
                      </div>
                      <div className="custom-pagination">
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => {
                                if (activeTab === "domains") {
                                  fetchIndustries(currentPage - 1);
                                } else if (activeTab === "specialties") {
                                  fetchSpecialities(currentPage - 1);
                                }
                              }}
                              disabled={currentPage === 1}
                            >
                              «
                            </button>
                          </li>

                          {/* نستخدم الدالة هنا */}
                          {renderPaginationItems()}

                          <li
                            className={`page-item ${
                              currentPage ===
                              (activeTab === "domains"
                                ? metadata?.totalPages
                                : metadataSpecialties?.totalPages)
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => {
                                if (activeTab === "domains") {
                                  fetchIndustries(currentPage + 1);
                                } else if (activeTab === "specialties") {
                                  fetchSpecialities(currentPage + 1);
                                }
                              }}
                              disabled={
                                currentPage ===
                                (activeTab === "domains"
                                  ? metadata?.totalPages
                                  : metadataSpecialties?.totalPages)
                              }
                            >
                              »
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* View Domain Specialties Modal */}
        <div
          className="modal fade"
          id="viewSpecialtiesModal"
          tabIndex="-1"
          aria-labelledby="viewSpecialtiesModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title" id="viewSpecialtiesModalLabel">
                  تخصصات{" "}
                  {selectedIndustryName ? (
                    <span>{selectedIndustryName}</span>
                  ) : null}
                </h5> */}

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {loading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" />
                  </div>
                ) : specialities.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead>
                        <tr>
                          <th className="text-center" width="50">
                            #
                          </th>
                          <th>التخصص</th>
                          <th>الوصف</th>
                          <th className="text-center" width="140">
                            الإجراءات
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {specialities.map((spec, index) => (
                          <tr key={spec.id}>
                            <td className="text-center">{index + 1}</td>
                            <td>{spec.name}</td>
                            <td>{spec.description}</td>
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => openEditSpecialtyModal(spec)}
                                title="تعديل التخصص"
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-muted mb-0">
                      لا توجد تخصصات لهذا المجال
                    </p>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  إغلاق
                </button>
                <button
                  className="btn btn-secondary-custom"
                  onClick={() => openEditSpecialtyModal(null)}
                >
                  <i className="fas fa-plus-circle me-2"></i>
                  <span>{t("addSpecialty")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Industry Modal --> */}
        <div
          className="modal fade"
          id="editIndustryModal"
          tabIndex="-1"
          aria-labelledby="editIndustryModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="editIndustryModalTitle"
                  data-i18n="editIndustry"
                >
                  {t("Industry.editTitle")}{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form id="editIndustryForm">
                  <input type="hidden" id="editIndustryId" />
                  <div className="mb-3">
                    <label htmlFor="editIndustryNameAr" className="form-label">
                      {t("Industry.nameAr")}{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="editIndustryNameAr"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editIndustryNameEn" className="form-label">
                      {t("Industry.nameEn")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="editIndustryNameEn"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="editIndustryDescription"
                      className="form-label"
                    >
                      {t("Industry.description")}
                    </label>

                    <textarea
                      className="form-control"
                      id="editIndustryDescription"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="editIndustryEnglishDescription"
                      className="form-label"
                    >
                      {t("Industry.englishDescription")}
                    </label>
                    <textarea
                      className="form-control"
                      id="editIndustryEnglishDescription"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="editIndustryImage" className="form-label">
                      {t("Industry.image")}
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="editIndustryImage"
                      accept="image/*"
                    />
                    <div
                      className="preview-container mt-2"
                      id="editIndustryImagePreview"
                    >
                      <img
                        src=""
                        alt="معاينة صورة القطاع"
                        className="img-fluid rounded industry-image-preview"
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-danger remove-image-btn"
                        id="removeEditIndustryImage"
                      >
                        <i className="fas fa-times"></i>{" "}
                        {t("Industry.removeImage")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("cancel")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary-custom"
                  id="updateIndustryBtn"
                  onClick={handleSaveIndustry}
                >
                  {t("buttons.update")}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Specialties Modal --> */}
        <div
          className="modal fade"
          id="editSpecialtyModal"
          tabIndex="-1"
          aria-labelledby="editSpecialtyModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="editSpecialtyModalLabel">
                  {modalMode === "edit"
                    ? t("Specialty.editTitle")
                    : t("Specialty.addTitle")}{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form id="editSpecialtyForm">
                  <input type="hidden" value={selectedSpecialty?.id || ""} />

                  <div className="mb-3">
                    <label className="form-label">{t("field")}</label>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadIndustriesOptions}
                      value={
                        selectedSpecialty?.industryId
                          ? {
                              value: selectedSpecialty.industryId,
                              label: selectedSpecialty.industryLabel || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        setSelectedSpecialty({
                          ...selectedSpecialty,
                          industryId: selectedOption?.value || "",
                          industryLabel: selectedOption?.label || "",
                        })
                      }
                      placeholder={t("select")}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">{t("nameAr")}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedSpecialty?.arabicName || ""}
                      onChange={(e) =>
                        setSelectedSpecialty({
                          ...selectedSpecialty,
                          arabicName: e.target.value,
                        })
                      }
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">{t("nameEn")}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedSpecialty?.englishName || ""}
                      onChange={(e) =>
                        setSelectedSpecialty({
                          ...selectedSpecialty,
                          englishName: e.target.value,
                        })
                      }
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">{t("description")}</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={selectedSpecialty?.arabicDescription || ""}
                      onChange={(e) =>
                        setSelectedSpecialty({
                          ...selectedSpecialty,
                          arabicDescription: e.target.value,
                        })
                      }
                      required
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {t("englishDescription")}
                    </label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={selectedSpecialty?.englishDescription || ""}
                      onChange={(e) =>
                        setSelectedSpecialty({
                          ...selectedSpecialty,
                          englishDescription: e.target.value,
                        })
                      }
                      required
                    ></textarea>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("cancel")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={async () => {
                    const payload = {
                      arabicName: selectedSpecialty.arabicName?.trim(),
                      englishName: selectedSpecialty.englishName?.trim(),
                      arabicDescription:
                        selectedSpecialty.arabicDescription?.trim(),
                      englishDescription:
                        selectedSpecialty.englishDescription?.trim(),
                      industryId: selectedSpecialty.industryId,
                    };
                    console.log("Sending payload:", payload);

                    if (modalMode === "edit" && selectedSpecialty.id) {
                      await handleEditSpecialty(selectedSpecialty.id, payload);
                    } else {
                      await handleAddSpecialty(payload);
                    }

                    const modalElement =
                      document.getElementById("editSpecialtyModal");
                    const instance = bootstrap.Modal.getInstance(modalElement);
                    instance?.hide();
                  }}
                >
                  {modalMode === "edit"
                    ? t("buttons.update")
                    : t("buttons.add")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboardLayout>
  );
};

export default IndestryManagementPage;
